import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const DeliveryIndicatorModalToggle = ({ onClick  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("button", {
        "aria-label": getLabel('common.tooltip'),
        className: "tooltip__button",
        onClick: onClick
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "questionmark"
    }));
};

export { DeliveryIndicatorModalToggle };
//# sourceMappingURL=DeliveryIndicatorModalToggle.js.map
